import * as Sentry from '@sentry/nextjs'
import type { ReactNode } from 'react'
import React from 'react'

export class ErrorBoundary extends React.Component<{ children: ReactNode }> {
    // biome-ignore lint/suspicious/noExplicitAny: errorInfo can be anything
    componentDidCatch(error: Error, errorInfo: any) {
        Sentry.captureException(error, { extra: errorInfo })
    }

    render() {
        return this.props.children
    }
}
